const THEMES = [
    {
        target: 'Highspot',
        desc: 'Best for – Spot page headers',
        id: 2,
        resize: true,
        specs: {
            width: 1280,
            height: 360,
            aspectRatio: 1280 / 360,
            css: '_Highspot.css'
        },
        templates: [
            {
                css: 'headerVs',
                label: 'Header Vs. Banner',
                colors: ['#47174D', '#47174D'],
                text: ['Coke', 'Vs', 'Pepsi'],
                placeholder: 'Highspot-headerVs.png'
            },
            {
                css: 'headerLogo',
                label: 'Header Logo Banner',
                colors: ['#F8F6F7', '#ffffff'],
                bg: 180,
                text: ['<img src="https://logo.clearbit.com/amazon.com" alt="Amazon">Amazon', '<img src="https://logo.clearbit.com/microsoft.com" alt="Microsoft">Microsoft'],
                placeholder: 'Highspot-headerLogo.png'

            },
            {
                css: 'headerTrophy',
                label: 'Header Trophy Banner',
                colors: ['#47174D'],
                text: ['Us', 'Compared to', 'Slack'],
                placeholder: 'Highspot-headerTrophy.png'
            },
            {
                css: 'headerHorns',
                label: 'Header Horns Banner',
                colors: ['#620DEC'],
                text: ['MS Teams', 'Vs', 'Facebook'],
                placeholder: 'Highspot-headerHorns.png'
            },
            {
                css: 'headerBrand',
                label: 'Header Brand Banner',
                colors: ['#9557e6'],
                text: ['Your slogan here.', 'Brand it, man.'],
                placeholder: 'Highspot-headerBrand.png'
            },
            {
                css: 'headerBilly',
                label: 'Header 1983 Banner',
                colors: ['#F7F6F7'],
                text: ['Compete', 'With a Rebel Yell'],
                placeholder: 'Highspot-headerBilly.png'
            }
        ]
    },
    {
        target: 'Cards',
        desc: 'Best for – Klue Card headers.',
        id: 1,
        resize: false,
        specs: {
            width: 580,
            height: 145,
            aspectRatio: 580 / 145,
            css: '_Cards.css'
        },
        templates: [
            {
                css: 'basicSmall__text',
                label: 'Basic Banner Small Text',
                colors: ['#7ac130', '#25c1d4'],
                bg: -45,
                height: 24,
                text: ["Type your text here!"],
                placeholder: 'Cards-basicSmall__text.png'
            },
            {
                css: 'basicLarge__text',
                label: 'Basic Banner Large Text',
                colors: ['#7ac130', '#25c1d4'],
                bg: -45,
                height: 42,
                text: ["Type your text right here!"],
                placeholder: 'Cards-basicLarge__text.png'
            },
            {
                css: 'basicSmall',
                label: 'Basic Banner Small',
                colors: ['#47174D', '#620DEC'],
                bg: -69,
                height: 24,
                placeholder: 'Cards-basicSmall.png'
            },
            {
                css: 'basicLarge',
                label: 'Basic Banner Large',
                colors: ['#47174D', '#620DEC'],
                bg: -69,
                height: 42,
                placeholder: 'Cards-basicLarge.png'
            },
            {
                css: 'customText',
                label: 'Custom Text Large',
                colors: ['#9557e6', '#74fac7'],
                bg: -69,
                text: ["LGTM! Banner!"],
                placeholder: 'Cards-customText.png'
            },
        ]
    },
    {
        target: 'Cards',
        desc: 'Best for – Card headers on Battlecards.',
        id: 1,
        resize: false,
        specs: {
            width: 580,
            height: 145,
            aspectRatio: 580 / 145,
            css: '_Cards.css'
        },
        templates: [
            {
                css: 'vsSmallBar',
                label: 'Vs. Banner with Bars Small',
                colors: ['#AA22AE', '#EE11A0'],
                bg: -69,
                height: 88,
                placeholder: 'Cards-vsSmallBar.png'
            },
            {
                css: 'vsLargeBar',
                label: 'Vs. Banner with Bars Large',
                colors: ['#AA22AE', '#EE11A0'],
                bg: -69,
                placeholder: 'Cards-vsLargeBar.png'
            },
            {
                css: 'vsSmall',
                label: 'Vs. Banner Small',
                colors: ['#47174D', '#620DEC'],
                bg: -69,
                height: 88,
                placeholder: 'Cards-vsSmall.png'
            },
            {
                css: 'vsLarge',
                label: 'Vs. Banner Large',
                colors: ['#47174D', '#620DEC'],
                bg: -69,
                placeholder: 'Cards-vsLarge.png'
            }
        ]
    },
    {
        target: 'Digest',
        desc: 'Best for – The Intel Digest custom banner.',
        id: 3,
        resize: false,
        specs: {
            width: 580,
            height: 100,
            aspectRatio: 580 / 100,
            css: '_Digest.css'
        },
        templates: [
            {
                css: 'standard',
                label: 'Simple',
                colors: ['#ec0065', '#3c1e7b'],
                bg: 65,
                text: ['Message goes here'],
                placeholder: 'Digest-standard.png'
            },
            {
                css: 'klue',
                label: 'Klue Branded',
                colors: [],
                text: ['Intel. Hot Cooked.'],
                placeholder: 'Digest-klue.png'
            }
        ]
    }
];

export default THEMES;
